<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <v-card
      max-width="344"
      :elevation="hover ? 10 : elevation"
      class="mx-auto"
      hover
      :ripple="!$slots.actions"
      :disabled="disabled"
      @click.stop="$emit('click')"
    >
      <v-list-item
        v-if="$slots.heading"
        :class="classes"
        :dark="primary"
      >
        <slot name="heading"/>
      </v-list-item>

      <template v-if="$slots.content">
        <slot name="content"/>
      </template>

      <v-card-text
        v-if="detail"
        v-html="detail"
      />

      <v-card-actions v-if="$slots.actions">
        <slot name="actions"/>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>

export default {
  props: {
    // size
    // TODO: small, largeによって大きさを変更できるようにする
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false,
    },
    // color
    primary: {
      type: Boolean,
      default: false
    },
    // etc...
    detail: {
      type: String,
      default: null,
    },
    elevation: {
      type: String,
      default: '1'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes() {
      return {
        'primary': this.primary,
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.primary
  height 60px
  background-color #2a5594 !important
  font-weight bold

.subtitle
  font-size 11px

.detail
  min-height 140px
</style>
